import { render, staticRenderFns } from "./AddBio.vue?vue&type=template&id=e4761736&scoped=true&"
import script from "./AddBio.vue?vue&type=script&lang=js&"
export * from "./AddBio.vue?vue&type=script&lang=js&"
import style0 from "./AddBio.vue?vue&type=style&index=0&id=e4761736&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4761736",
  null
  
)

export default component.exports